import { useQuery } from 'react-query';
import { fetchExpandedCollections } from '../api';
import { transformCreatorCollection } from '../transforms';
import { FormattedCreatorCollection } from '../types';

interface ExpandHookResponse {
    creatorCollections: {
        collections: FormattedCreatorCollection[];
        objectCount: number;
    };
}

export const useExpandCreatorCollections = (
    eventId: string,
    options: { enabled: boolean },
) => {
    const query = useQuery<ExpandHookResponse>(
        [eventId, 'public-collection-expand'],
        async () => {
            const data = await fetchExpandedCollections(eventId);

            const formattedData: FormattedCreatorCollection[] = data.collections.map(
                transformCreatorCollection,
            );

            return {
                creatorCollections: {
                    collections: formattedData,
                    objectCount: formattedData.length,
                },
            };
        },
        {
            enabled: options.enabled,
        },
    );

    return query;
};
